export type ReportValueLabels = {
  main: string;
  canceled: string;
};

const LABELS: Record<string, ReportValueLabels> = {
  amount: { main: "Aktív bevétel", canceled: "Törölt bevétel" },
  count: { main: "Aktív foglalások (db)", canceled: "Törölt foglalások (db)" },
  guests: { main: "Aktív foglalások (fő)", canceled: "Törölt foglalások (fő)" },
  canceled_amount: { main: "Törölt bevétel", canceled: "" },
  canceled_count: { main: "Törölt foglalások (db)", canceled: "" },
  canceled_guests: { main: "Törölt foglalások (fő)", canceled: "" },
  refund_amount: { main: "Visszatérítés", canceled: "" },
  refund_guests: { main: "Refund létszám", canceled: "" },
  admin_fee_amount: { main: "Admin Fee összeg", canceled: "" },
  closed_event_count: { main: "Kis létszám miatt elmarad", canceled: "" },
  program_closed_count: { main: "Lezárt programok száma", canceled: "" },
  utilization: { main: "Telítettség %", canceled: "" },
};

export function getReportValueLabels(value?: string): ReportValueLabels {
  return LABELS[value ?? ""] ?? { main: value ?? "", canceled: "Törölt" };
}
